import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import './Header.css';

import Logo from '../../assets/images/Xenvota.png'

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <nav className="nav">
            <div className="nav-brand">
              <img src={Logo} onClick={() => scrollToSection('hero')}/>
            </div>

            <div className="nav-menu">
              <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
              <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
              <button onClick={() => scrollToSection('projects')} className="nav-link">Projects</button>
              {/* <button onClick={() => scrollToSection('team')} className="nav-link">Team</button> */}
              <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
            </div>

            <div className="nav-toggle" onClick={toggleMenu}>
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </div>
          </nav>
        </div>
      </header>

      {/* Mobile Menu - Outside the header */}
      <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <button onClick={() => scrollToSection('about')} className="mobile-nav-link">About</button>
        <button onClick={() => scrollToSection('services')} className="mobile-nav-link">Services</button>
        <button onClick={() => scrollToSection('projects')} className="mobile-nav-link">Projects</button>
        <button onClick={() => scrollToSection('team')} className="mobile-nav-link">Team</button>
        <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
      </div>
    </>
  );
};

export default Header; 